<template>
	<div class="process-detail layout-row">
		<div class="set-up-team block">
			<div class="process-line layout-row">
				<div class="line-item" :class="checkBar(bar_list[0])"></div>
				<div class="line-item" :class="checkBar(bar_list[1])"></div>
			</div>
			<div class="title color-text1">成立小組</div>
			<div class="detail layout-column">
				<div class="layout-row" :class="checkItem(bar_list[0])">
					<div class="icon">
						<i class="el-icon-success color-success" v-if="bar_list[0]"></i>
					</div>
					填寫小組成員資訊
				</div>
				<div class="layout-row" :class="checkItem(bar_list[1])">
					<div class="icon">
						<i class="el-icon-success color-success" v-if="bar_list[1]"></i>
					</div>
					加入其他輔導員夥伴
				</div>
			</div>
		</div>
		<div class="problem block">
			<div class="process-line layout-row">
				<div class="line-item" :class="checkBar(bar_list[2])"></div>
				<div class="line-item" :class="checkBar(bar_list[3])"></div>
				<div class="line-item" :class="checkBar(bar_list[4])"></div>
				<div class="line-item" :class="checkBar(bar_list[5])"></div>
				<div class="line-item" :class="checkBar(bar_list[6])"></div>
				<div class="line-item" :class="checkBar(bar_list[7])"></div>
			</div>
			<div class="title color-text1">進行 DFC 四階段</div>
			<div class="detail layout-column">
				<div class="layout-row" :class="checkItem(bar_list[2])">
					<div class="icon">
						<i class="el-icon-success color-success" v-if="bar_list[2]"></i>
					</div>
					感受到的問題
				</div>
				<div class="layout-row" :class="checkItem(bar_list[3])">
					<div class="icon">
						<i class="el-icon-success color-success" v-if="bar_list[3]"></i>
					</div>
					四階段照片
				</div>
				<div class="layout-row" :class="checkItem(bar_list[4])">
					<div class="icon">
						<i class="el-icon-success color-success" v-if="bar_list[4]"></i>
					</div>
					挑戰學習單
				</div>
				<div class="layout-row" :class="checkItem(bar_list[5])">
					<div class="icon">
						<i class="el-icon-success color-success" v-if="bar_list[5]"></i>
					</div>
					挑戰故事授權同意書(非必填)
				</div>
				<div class="layout-row" :class="checkItem(bar_list[6])">
					<div class="icon">
						<i class="el-icon-success color-success" v-if="bar_list[6]"></i>
					</div>
					影片
				</div>
				<div class="layout-row" :class="checkItem(bar_list[7])">
					<div class="icon">
						<i class="el-icon-success color-success" v-if="bar_list[7]"></i>
					</div>
					故事之 SDGs 分類
				</div>
			</div>
		</div>
		<div class="story-data block">
			<div class="process-line layout-row">
				<div class="line-item" :class="checkBar(bar_list[8])"></div>
				<div class="line-item" :class="checkBar(bar_list[9])"></div>
				<div class="line-item" :class="checkBar(bar_list[10])"></div>
			</div>
			<div class="title color-text1">小組成員基本資料</div>
			<div class="detail layout-column">
				<div class="layout-row" :class="checkItem(bar_list[8])">
					<div class="icon">
						<i class="el-icon-success color-success" v-if="bar_list[8]"></i>
					</div>
					國際證書資料
				</div>
				<div class="layout-row" :class="checkItem(bar_list[9])">
					<div class="icon">
						<i class="el-icon-success color-success" v-if="bar_list[9]"></i>
					</div>
					輔導員問卷
				</div>
				<div class="layout-row" :class="checkItem(bar_list[10])">
					<div class="icon">
						<i class="el-icon-success color-success" v-if="bar_list[10]"></i>
					</div>
					參加分享季
				</div>
			</div>
		</div>
		<div class="finish-story block">
			<div class="process-line layout-row">
				<div class="line-item" :class="checkBar(bar_list[11])"></div>
			</div>
			<div class="title color-text1">完成 DFC 挑戰</div>
			<div class="detail layout-column">
				<div class="layout-row" :class="checkItem(bar_list[11])">
					<div class="icon">
						<i class="el-icon-success color-success" v-if="bar_list[11]"></i>
					</div>
					DFC Taiwan 審核完成
				</div>
			</div>
		</div>
	</div>
</template>

<script>
const _ = require("lodash");

export default {
	props: {
		progress: {
			type: Object,
			default: function () {
				return {
					bar_list: []
				};
			}
		}
	},
	data() {
		return {};
	},
	computed: {
		message() {
			return this.progress.message;
		},
		bar_list() {
			return this.progress.bar_list;
		}
	},
	methods: {
		checkBar(bool) {
			return bool ? "active" : "";
		},
		checkItem(bool) {
			return bool ? "color-text1" : "color-text3";
		}
	},
	created() { },
	mounted() { },
	components: {}
};
</script>

<style lang="scss" scoped>
.process-detail {
	.block {
		width: 100%;

		.title {
			font-size: 14px;
			font-weight: 500;
			margin-bottom: 10px;
		}
	}

	.block:not(:first-child) {
		margin-left: 20px;
	}

	.process-line {
		width: 100%;
		margin-bottom: 10px;

		.line-item {
			width: 100%;
			height: 5px;
			border-radius: 5px;
			background-color: #cacfd4;
		}

		.line-item.active {
			background-color: #60adf5;
		}

		.line-item:not(:first-child) {
			margin-left: 5px;
		}
	}

	.detail {
		font-size: 12px;

		.icon {
			width: 14px;
			height: 14px;
			margin-right: 5px;
		}
	}

	.set-up-team {
		flex: 2;
	}

	.problem {
		flex: 3;

		.detail {
			justify-content: space-between;
		}
	}

	.story-data {
		flex: 2;
	}

	.finish-story {
		flex: 2;
	}
}
</style>